<script lang="ts">
  import FormErrors from "@shared/svelte/Components/FormErrors.svelte";
  import { OnLayoutChange } from "@shared/svelte/Directives/OnLayoutChange.js";
  import { pageErrorStore } from "@retailer/svelte/stores/PageErrorStore";

  export let useBackgroundWhite = true;
  let { errors } = pageErrorStore;
  // usage:
  // let errors:Errors = {messages: ['test']}
  // pageErrorStore.errors.update(_ => errors)

  let mobileMode = null;
  function updateMobileMode(name: string) {
    mobileMode = name == "mobile";
  }
</script>

<div
  class:background-white={useBackgroundWhite}
  use:OnLayoutChange={updateMobileMode}
  class="fizz-styles"
>
  <FormErrors bind:errors={$errors} />
  <slot {mobileMode} />
</div>
